import {
  Button,
  SingleFieldDialog,
  SingleFieldDialogHeader,
  SingleFieldDialogCTA,
} from "@sellar-io/components";
import { usePriceTierVolumeDiscountsDelete } from "../../../hooks/api/v2/priceTierVolumeDiscounts/usePriceTierVolumeDiscountsDelete";

export const PriceTierVolumeDiscountDeleteDialog = ({
  active,
  onDismiss,
  priceTierVolumeDiscountsId,
  priceTierId,
  volumeDiscountsSetName,
  priceTierName,
}: {
  active: boolean;
  onDismiss: () => void;
  priceTierVolumeDiscountsId: number;
  priceTierId: number;
  volumeDiscountsSetName?: string;
  priceTierName?: string;
}) => {
  const deleteMutation = usePriceTierVolumeDiscountsDelete(
    priceTierId,
    priceTierVolumeDiscountsId,
  );

  const handleRemove = () => {
    deleteMutation.mutate(undefined, {
      onSuccess: () => {
        onDismiss();
      },
    });
  };

  const title = volumeDiscountsSetName
    ? `Are you sure you want to remove this '${volumeDiscountsSetName}' volume discount set from this price list?`
    : `Are you sure you want to remove this volume discount set from '${priceTierName}' price list?`;

  return (
    <SingleFieldDialog active={active} onDismiss={onDismiss}>
      <SingleFieldDialogHeader
        title={title}
        description="You can add it back on at any time"
        icon="INFORMATION"
        iconClassName="bg-red-50 text-red-600"
      />
      <SingleFieldDialogCTA>
        <Button color="transparent" onClick={onDismiss}>
          Dismiss
        </Button>
        <Button
          color="red"
          onClick={handleRemove}
          loading={deleteMutation.isPending}
        >
          Remove
        </Button>
      </SingleFieldDialogCTA>
    </SingleFieldDialog>
  );
};
